<template>
  <div>
    <!-- <div>
      <el-form ref="formFilter" :model="formFilter" label-width="75px" label-position="right" @submit.native.prevent>
        <filter-box :item-width="300">
          <el-form-item label="申请日期">
            <date-range class="filter-item" v-model="formFilter.createDate" :clearable="true" :allowTypes="['day']"
              align="left" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-button slot="operator" type="default" @click="onReset()" :plain="true">重置</el-button>
          <el-button slot="operator" type="primary" @click="onSearch()" :plain="true">查询</el-button>
        </filter-box>
      </el-form>
    </div> -->
    <div>
      <el-table header-cell-class-name="table-header-gray" :data="tableHead">
        <el-table-column label="任务名称" prop="taskName">
        </el-table-column>
        <el-table-column label="任务描述" prop="description"> </el-table-column>
        <el-table-column label="责任人" prop="assignee"> </el-table-column>
        <el-table-column label="创建时间" prop="createdTime"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { findTreeNodePath } from "@/utils";
import { uploadMixin } from "@/core/mixins";
import {
  changeReportController
} from "@/api";
export default {
  props: {
    rowData: Object,
  },
  mixins: [uploadMixin],
  data() {
    return {
      formFilter: {
        createDate: [],
      },
      tableHead: [],
    };
  },
  methods: {
    onSearch() {
      var date = this.formFilter.createDate;
      var params = {};
      if (date.length > 0) {
        params['startTime'] = date[0];
        params['endTime'] = date[1];
      }
      this.loadData(params);
    },
    initData(data) {
      this.tableHead = data;
    },
    loadData(params) {
      var _that = this;
      changeReportController.dueList(this, params)
        .then((res) => {
          _that.initData(res.data);
        })
        .catch((e) => {

        });
    },
    onReset() {
      this.formFilter.createDate = [];
      this.onSearch();
    },
  },
  computed: {
    isEdit() {
      return this.formData.userId != null;
    },
  },
  mounted() {
    this.loadData({});
  }
};
</script>

<style lang="scss" scoped></style>
